import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import HeaderButtons from 'profile/components/header_buttons';
import { toggleRightDrawer } from 'header/ducks';
import { getPortfolio, toggleEditMode } from 'profile/ducks/portfolio';

export function mapStateToProps(state, { location, params }) {
  const currentLocation = location.pathname;
  return {
    user: state.user,
    isEditing: currentLocation.indexOf('/edit') !== -1,
    profileUsername: params.profileUsername,
    portfolio: !!currentLocation.match(/portfolio/),
    yourEntries: !!currentLocation.match(/your-entries/),
    portfolioEditMode: getPortfolio(state).editMode,
    isLoading: state.profile.view.isLoading
  };
}

export default withRouter(connect(mapStateToProps, {
  togglePortfolioEdit: toggleEditMode,
  toggleRightDrawer
})(HeaderButtons));



// WEBPACK FOOTER //
// ./profile/containers/header_button.js